// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"6efaa3b2","194":"f0f80026","367":"c766ea1f","472":"3ca223cf","496":"6128b9ba","541":"dc4c17ee","586":"0d321d36","672":"5002ea54","699":"6586acdb","934":"96da817f"}[chunkId] + ".chunk.js";
};